import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-data-group',
  standalone: true,
  imports: [ ],
  templateUrl: './table-data-group.component.html',
  styleUrl: './table-data-group.component.scss'
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class TableDataGroupComponent {}
